import { isDevOnboardingForced } from '@/utils/devOnboardingForce'
import { isOnboardingPreview } from '@/utils/devOnboardingPreview'

type ShellUser = { onboarded?: boolean; email?: string } | null | undefined

/**
 * True while onboarding (the guide) should own the shell.
 *
 * Requires a loaded user so the loading screen cannot treat a missing
 * profile as "still onboarding" and bounce real dashboard deep links.
 * Dev harness accounts can force onboarding on after `onboarded` is true.
 * The onboarding preview iframe can park it on one chapter without
 * changing `onboarded`.
 */
export function isOnboardingShellLocked(user: ShellUser): boolean {
    if (!user) return false
    if (isOnboardingPreview()) return true
    return !user.onboarded || isDevOnboardingForced(user.email)
}
